import { isMoment } from 'moment';
import {
  extractDateTimePartsInUTC,
  extractMomentDateTimeParts,
  extractMomentDateTimePartsInUTC,
} from '../../../parsers/dateInput/helpers/dateHelpers';
import { isIsoDate } from '../../normalizeDate/helpers/isIsoDate';
import { DateTimeParts, InkDateType, timeZoneSource } from '../../../types';
import { extractPartialIsoDateTime } from '../partialsoDateTime/extractPartialIsoDateTime';

export function extractStandardDateTimeParts(value: InkDateType): [DateTimeParts, timeZoneSource] | undefined {
  if (!value) return undefined;

  if (value instanceof Date && !isNaN(value.getTime())) {
    return [extractDateTimePartsInUTC(value), 'utc'];
  }

  if (isMoment(value)) {
    if (value.isUTC()) {
      return [extractMomentDateTimePartsInUTC(value), 'utc'];
    }

    return [extractMomentDateTimeParts(value), 'local'];
  }

  if (typeof value === 'string') {
    if (isIsoDate(value)) {
      const date = new Date(value);
      return [extractDateTimePartsInUTC(date), 'utc'];
    }
    const partialIsoDateTime = extractPartialIsoDateTime(value);
    return partialIsoDateTime && [partialIsoDateTime, 'local'];
  }

  return undefined;
}
